<template>
  <div style="display: inline;">
    <el-descriptions ref="desc" size="mini" :inline="false" :colon="false" :model="yt.conditions" class="demo-form-inline" :size="100">
      <el-descriptions-item :label="$t('mujubianhao')">
        {{ $attrs.mold.no }}
      </el-descriptions-item>
      <el-descriptions-item :label="$t('mujubianma')">
        {{ $attrs.mold.code }}
      </el-descriptions-item>
      <el-descriptions-item :label="$t('mujumingcheng')">
        {{ $attrs.mold.name }}
      </el-descriptions-item>
    </el-descriptions>
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/mold/insert/change/record/page" getKey="rows" :columns="columns"></yi_curd_table>
  </div>
</template>

<script>
export default {
  name: "web_base_mould_insert_change_record",
  data() {
    return {
      columns: [
        {
          label: "caozuoshijian",
          prop: "createTime",
          type: "time",
          // format: "YYYY-MM-DD HH:mm:ss",
          width: 180,
        },
        {
          label: "caozuoren",
          prop: "createByObject.nickname",
          width: 130,
        },
        {
          label: "genghuanqianxiangjianbianma",
          prop: "preInsert.code",
        },
        {
          label: "genghuanqianxiangjianmingcheng",
          prop: "preInsert.name",
        },
        {
          label: "genghuanhouxiangjianbianma",
          prop: "currentInsert.code",
        },
        {
          label: "genghuanhouxiangjianmingcheng",
          prop: "currentInsert.name",
        },
      ],
    };
  },
  created() {
    setTimeout(() => {
      this.yt.get(1, this.beforeGet);
    }, 300);
  },
  methods: {
    beforeGet(params) {
      this.$set(params, 'moldId', this.$attrs.mold.id);
      this.$set(params, 'orderBy', 'id desc');
      return params;
    },
  },
}
</script>

<style scoped>

</style>